import React from 'react';
import { ScoutingAgg } from './types';

interface TeamAveragesProps {
  teamAverages: {
    performanceAvg: number | null;
    scouting: ScoutingAgg | null;
    weakestKeys: string[];
  };
}

const TeamAverages: React.FC<TeamAveragesProps> = ({ teamAverages }) => {
  return (
    <div className="mt-4 rounded border border-gray-200 dark:border-gray-800 p-3">
      <h3 className="text-sm font-semibold text-gray-700 dark:text-gray-200 mb-2">Team Averages (Selected XI)</h3>
      <div className="text-xs text-gray-600 dark:text-gray-300 mb-2">
        Performance rating: <span className="font-semibold text-gray-900 dark:text-gray-100">{teamAverages.performanceAvg ?? '—'}</span>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-3 gap-2 text-xs">
        {(['shooting','passing','pace','dribbling','defending','physical'] as const).map((k) => {
          const labelMap: Record<string, string> = {
            shooting: 'Shooting',
            passing: 'Passing',
            pace: 'Pace',
            dribbling: 'Dribbling',
            defending: 'Defending',
            physical: 'Physical',
          };
          const val = teamAverages.scouting ? (teamAverages.scouting as any)[k] : null;
          const isWeak = teamAverages.weakestKeys.includes(k);
          return (
            <div key={k} className={`flex items-center justify-between rounded px-2 py-1 border ${isWeak ? 'border-red-300 dark:border-red-800 bg-red-50 dark:bg-red-900/20' : 'border-gray-200 dark:border-gray-800'}`}>
              <span className="text-gray-700 dark:text-gray-200">{labelMap[k]}</span>
              <span className={`font-semibold ${isWeak ? 'text-red-700 dark:text-red-300' : 'text-gray-900 dark:text-gray-100'}`}>{val ?? '—'}</span>
            </div>
          );
        })}
      </div>
      {teamAverages.scouting && teamAverages.weakestKeys.length > 0 && (
        <div className="mt-2 text-xs text-gray-700 dark:text-gray-200">
          Weakest areas: <span className="font-semibold capitalize">{teamAverages.weakestKeys.join(', ')}</span>
        </div>
      )}
    </div>
  );
};

export default TeamAverages;
